import { ApiError, useApiPost } from '../../../api';
import { useMutation } from 'react-query';
import { useBuildVars } from '../../../config';

export type MarginStrategy =
  | 'REPLACEMENT_COST'
  | 'RETAIL_PRICE'
  | 'RETAIL_DELTA';

export type Priority = 'STANDARD' | 'URGENT';
export type ProgramAttribute = {
  attributeName: string;
  attributeValue: string;
  id: number;
  itemId?: string;
};
export type ProgramAttributesType = {
  attributes: ProgramAttribute[];
  vendorCode: string;
};

export type RuleSubmitRequest = {
  autoDenialJustification: string;
  bussinessJustificationId: number;
  comment: string;
  countryCode: string;
  customerBranchNumber: string;
  customerCompanyCode: string;
  customerNumber: string;
  effectiveDate: string;
  expirationDate: string;
  marginStrategy: MarginStrategy;
  modPercent: number;
  programAttributes?: ProgramAttributesType;
  requestPriority: Priority;
  requestProcessingType: 'VALIDATION' | 'LOAD';
  segmentId: number;
  supressAutoDenial: boolean;
  vendorCompanyCode: string;
  vendorNumber: string;
};

export type RuleSubmitResponse = {
  requestId: string;
  trackingUrl: string;
};

export function useRuleSubmit() {
  const buildVars = useBuildVars();
  const apiPost = useApiPost<RuleSubmitResponse>({
    host: buildVars.PRICING_API_BASE,
  });

  return useMutation((req: RuleSubmitRequest) =>
    apiPost('/singleRuleUpload', req, [], {
      'IM-RequestPriority': req.requestPriority,
    }).catch((err) => {
      const errResponse = err?.response;
      throw new ApiError(
        errResponse?.type || errResponse?.message
          ? `${errResponse?.type}: ${errResponse?.message}`
          : err?.message ?? 'Something went wrong',
        errResponse?.status ?? 0
      );
    })
  );
}
